import _ from 'underscore';
import Backbone from 'backbone';

// Return a new object with Backbone.Events functions mixed in
//
// This is in effect a global event stream for page-level events
const dispatcher = _.extend({}, Backbone.Events);
export default dispatcher;
